module.exports = __webpack_public_path__ + "img/1-1ZGG64556102.9e412bde.png";